import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType, Headers, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
declare var $;

@Injectable()
export class ContratosService {

  private service_url : string = null;
  private contratosServiceUrl : string = null;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
        this.service_url = this.constantsService.apiURL + '/contratos/files';
        this.contratosServiceUrl = this.constantsService.apiURL + '/contratos';
  }

  get(idCreditos : number) {
    let serviceUrl = this.service_url + '?id='+ idCreditos;
    return this.http.get(serviceUrl , this.authService.getAuthHeaders());
  }

  public delete(idCreditos : number) {
    let serviceUrl = this.service_url + '?id='+ idCreditos;
    return this.http.delete(serviceUrl , this.authService.getAuthHeaders());
  }

  public save( event : any, idCreditos: number) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
        let file: File = fileList[0];
        let formData : FormData = new FormData();
        formData.append('id', idCreditos+'');
        formData.append('imagen', file, file.name);
        let headers = new Headers();
        /** In Angular 5, including the header Content-Type can invalidate your request */
        //headers.append('Content-Type', 'multipart/form-data');

        return this.http.post(this.service_url , formData, this.authService.getAuthHeaders());
    }
  }

  public getImageUrl(id) {
    const options = this.authService.getAuthHeaders();
    let serviceUrl = this.service_url + '?id='+ id + '&action=download';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

  public getContratoPDF(id) {
    const options = this.authService.getAuthHeaders();
    let serviceUrl = this.contratosServiceUrl + '/'+ id + '?action=download';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

  public exportToExcel(filters : any) {
    let myParams = new URLSearchParams();
    myParams.append('action', 'download');
    
    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    let serviceUrl = this.service_url + '/general/export';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contratos.service.ts